<template>
    <div>
        <div class="message">
            You've received new alert on MultiMe!
        </div>
        <div class="message" style="margin-top: 5px;">
            <a href="/notifications/" class="btn btn-small btn-primary">Open Alerts</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WsNewAlertNotification"
    };
</script>
